import { INavigationItem, INavigationItemSimple } from "./types";
import {
  IconControlNav,
  IconHomeNav,
  IconMaintenanceNav,
  IconMonitoringNav,
  IconOrdersNav,
  IconProductsPortfolioNav,
  IconStoreNav,
  IconSystemNav,
  IconUser,
  IconUsers,
} from "../../assets";
import { AnyMongoAbility } from "@casl/ability";

const getAccessRoute = (routes: Record<string, boolean>) => {
  let accessRoute = "";
  Object.keys(routes).forEach((route) => {
    if (routes[route] && !accessRoute) {
      accessRoute = route;
    }
  });
  return accessRoute;
};

export const getOrganizationItems = (ability: AnyMongoAbility) => {
  const items = [];
  if (
    ability.can("metadata:get", "products") ||
    ability.can("get", "products")
  ) {
    items.push({
      route: getAccessRoute({
        "/products-portfolio/portfolio": ability.can("get", "products"),
        "/products-portfolio/metadata": ability.can("metadata:get", "products"),
      }),
      translationKey: "productsPortfolio",
      nestedItems: [],
      icon: <IconProductsPortfolioNav />,
      access: "products:get|products:metadata:get",
      tenantLevel: true,
    });
  }

  return items;
};

export const getProfileItems = () => {
  return [
    {
      route: "/profile",
      translationKey: "profile",
      nestedItems: [],
      icon: <IconUser />,
      access: "all",
      tenantLevel: true,
    },
  ];
};

export const getRegularItems = (ability: AnyMongoAbility) => {
  if (!ability.can("get", "systems")) {
    return [];
  }
  const items = [];
  if (ability.can("get", "orders")) {
    items.push({
      route: "/orders",
      translationKey: "orders",
      nestedItems: [],
      icon: <IconOrdersNav />,
    });
  }
  if (ability.can("get", "stock")) {
    items.push({
      route: "/stock",
      translationKey: "stock",
      nestedItems: [],
      icon: <IconSystemNav />,
    });
  }
  if (ability.can("get", "stock") && ability.can("create", "orders")) {
    items.push({
      route: "/store",
      translationKey: "store",
      nestedItems: [],
      icon: <IconStoreNav />,
    });
  }
  return items;
};

export const getItems = (
  isOrganization: boolean,
  ability: AnyMongoAbility,
  pathname: string
) => {
  if (pathname.includes("/profile")) {
    return getProfileItems();
  }
  if (isOrganization) {
    return getOrganizationItems(ability);
  }
  return getRegularItems(ability);
};

export const findItemKeyByRoute = (route: string, ability: AnyMongoAbility) => {
  let item: INavigationItemSimple | undefined;
  [
    ...getRegularItems(ability),
    ...getOrganizationItems(ability),
    ...getProfileItems(),
  ].forEach((navigationItem) => {
    if (navigationItem.route === route) {
      item = navigationItem;
      return;
    }
    if (navigationItem.nestedItems) {
      navigationItem.nestedItems.forEach((nestedItem: INavigationItem) => {
        if (nestedItem.route === route) {
          item = nestedItem;
          return;
        }
      });
    }
  });
  return item;
};

export const findSubKeyByRoute = (route: string, ability: AnyMongoAbility) => {
  let item: INavigationItem | undefined;
  [...getRegularItems(ability), ...getOrganizationItems(ability)].forEach(
    (navigationItem) => {
      if (
        navigationItem.route === route ||
        navigationItem.nestedItems.find(
          (i: INavigationItem) => i.route === route
        )
      ) {
        item = navigationItem;
        return;
      }
    }
  );
  return item;
};
